import { useMemo } from "react";

import { Company, Deal, Person } from "@mapmycustomers/shared/types/entity";
import User from "@mapmycustomers/shared/types/User";

const useAllowedUsers = (
  users: User[],
  record: Company | Deal | Person,
  allAllowed?: boolean
): User[] => {
  const allowedByAssociationsUserIds = useMemo(
    () =>
      new Set([
        ...((record as Company).parentAccount?.userIds ?? []),
        ...((record as Deal).account?.userIds ?? []),
        ...((record as Deal).contact?.userIds ?? []),
        ...((record as Person).accounts?.flatMap(({ userIds }) => userIds) ?? []),
        // users with access to record
        ...(record.userIds ?? []),
      ]),
    [record]
  );

  return useMemo(
    () =>
      allAllowed
        ? users
        : users.filter(
            (user) =>
              // All Teammates and Owner and Current User
              user.viaTeamAccess ||
              // users which have access to associated entities
              allowedByAssociationsUserIds.has(user.id)
          ),
    [allowedByAssociationsUserIds, users, allAllowed]
  );
};

export default useAllowedUsers;
